// src/v2/components/GDS/CardV2/index.tsx

import React, { useRef, useEffect } from 'react';
import { CardV2 } from 'pepsico-ds';

export interface CardV2WrapperProps {
  state?: 'interactive' | 'non-interactive' | 'scrollable';
  cardHeader?: any;
  cardBody?: any;
  type?: 'basic' | 'withImage' | 'withBackgroundImage';
  cardFooter?: React.ReactNode;
  cardImage?: string | React.ReactNode;
  cardActions?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  viewport?: 'desktop' | 'mobile';
  nested?: boolean;
}

const CardV2Wrapper: React.FC<CardV2WrapperProps> = ({
  children,
  state = 'non-interactive',
  cardHeader,
  cardBody,
  type = 'basic',
  style,
  ...rest
}) => {
  const cardRef = useRef<HTMLDivElement>(null);

  // Hide empty card-header div when cardHeader prop is not provided
  useEffect(() => {
    if (cardHeader == null && cardRef.current) {
      const headerDiv = cardRef.current.querySelector('.card-header');
      if (headerDiv instanceof HTMLElement) {
        headerDiv.style.display = 'none';
      }
    }
  }, [cardHeader]);

  // Build props object, only including cardHeader if it has a value
  // This prevents CardV2 from rendering an empty header div when cardHeader is undefined
  const cardProps = {
    state,
    cardBody,
    type,
    style: { width: '100%', ...style },
    ...rest,
    ...(cardHeader != null && { cardHeader }),
  };

  return (
    <div ref={cardRef}>
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      <CardV2 {...(cardProps as any)}>{children}</CardV2>
    </div>
  );
};

export default CardV2Wrapper;
